// -------------------------------------------------------------------------
//  Functionalities for displaying and controlling data
// -------------------------------------------------------------------------

  document.addEventListener("DOMContentLoaded", function () {
    // Check if salesSettings exists
    if (typeof window.salesSettings === "undefined") {
      console.error("Sales settings not found.");
      return; // Exit if salesSettings is not defined
    }

    // Get sale state from window.salesSettings
    const saleAvailable = window.salesSettings.saleAvailable;

    // Log the entire salesSettings object for debugging
    console.log("Checking for sales settings:", window.salesSettings);

    // Set and update the body data-sale attribute and classes
    let saleState = "unknown"; // Default state

    if (saleAvailable === "true") {
      saleState = "sale-active";
    } else if (saleAvailable === "coming_soon") {
      saleState = "coming-soon";
    } else if (saleAvailable === "false") {
      saleState = "sale-inactive";
    }

    // Update body attributes and classes
    document.body.setAttribute("data-sale", saleState);
    document.body.classList.add(saleState);

    console.log(`Sale Status: ${saleState}`);

    // Update product price classes based on sale availability
    const productPrices = document.querySelectorAll(".product-grid--price");
    productPrices.forEach((price) => {
      if (saleState === "sale-active") {
        price.classList.add("sale-available");
        price.classList.remove("sale-unavailable");
      } else {
        price.classList.add("sale-unavailable");
        price.classList.remove("sale-available");
      }
    });

    console.log(`Sale is ${saleAvailable}.`);
  });


  document.addEventListener("DOMContentLoaded", function () {
    if (window.salesSettings) {
      console.log("Sale Available:", window.salesSettings.saleAvailable);
    }
  });

  console.log("Checking for sales settings:", window.salesSettings);